import { render, staticRenderFns } from "./VideoFullscreen.vue?vue&type=template&id=2266bb6c&scoped=true&"
import script from "./VideoFullscreen.vue?vue&type=script&lang=js&"
export * from "./VideoFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoFullscreen.vue?vue&type=style&index=0&id=2266bb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266bb6c",
  null
  
)

export default component.exports